import React from 'react';
import { Outlet } from 'react-router-dom';
import StudentNavbar from '../components/StudentNavbar';

const DashboardLayout = () => {
  const isImpersonating = Boolean(localStorage.getItem('adminToken'));
  const stopImpersonation = () => {
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      localStorage.setItem('token', adminToken);
      localStorage.removeItem('adminToken');
      window.location.reload();
    }
  };
  return (
    <div className="min-h-screen bg-slate-50/70">
      <StudentNavbar />
      {isImpersonating && (
        <div className="mx-auto mt-4 flex max-w-7xl items-center justify-between rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900 shadow-sm">
          <span className="text-sm font-medium">Impersonation active</span>
          <button onClick={stopImpersonation} className="text-sm font-semibold text-blue-700 underline-offset-2 hover:underline">Stop Impersonation</button>
        </div>
      )}
      <main className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
